var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.333344C5.55 0.333344 0.333336 5.55001 0.333336 12C0.333336 20.75 12 33.6667 12 33.6667C12 33.6667 23.6667 20.75 23.6667 12C23.6667 5.55001 18.45 0.333344 12 0.333344ZM12 16.1667C9.7 16.1667 7.83334 14.3 7.83334 12C7.83334 9.70001 9.7 7.83334 12 7.83334C14.3 7.83334 16.1667 9.70001 16.1667 12C16.1667 14.3 14.3 16.1667 12 16.1667Z",
    fill: "#1B5E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocal);
export default __webpack_public_path__ + "static/media/local.359009ad290a1d1124419d425bbacbf7.svg";
export { ForwardRef as ReactComponent };